// extracted by mini-css-extract-plugin
module.exports = {"col":"Logos_col__3CH3m","row":"Logos_row__2SH0O","dark":"Logos_dark__5MvYK","logos":"Logos_logos__10Blb"};